import React, { Component } from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
library.add(faCheck);

// Return a array range from low to high number
function range(low, hi) {
  function rangeRec(low, hi, vals) {
    if (low > hi) return vals;
    vals.push(low);
    return rangeRec(low + 1, hi, vals);
  }
  return rangeRec(low, hi, []);
}

class ProgressBar extends Component {
  constructor(props) {
    super();
  }

  render() {
    // Get current step and total step from props
    let currentStep = this.props.currentStep;
    let totalStep = this.props.totalStep;
    // This value is percentage for each step
    let percentage = Math.round((100 / (totalStep - 1)) * 100) / 100;
    // calculated current step percetange
    let progressPercentage = (currentStep - 1) * percentage;
    let totalArray = range(0, totalStep - 1);

    return (
      <div className='progress hide-on-print'>
        <div
          className='progress-bar progress-bar-animated'
          style={{ width: progressPercentage + '%' }}
        ></div>
        {
          // Map the array to generated the html and css
          totalArray.map((number, i) => (
            <div
              key={i}
              style={{ left: percentage * number + '%' }}
              className={
                number >= currentStep
                  ? 'progress-step'
                  : 'step-completed progress-step'
              }
            >
              {number >= currentStep - 1 ? (
                number + 1
              ) : (
                <FontAwesomeIcon icon={faCheck} />
              )}
            </div>
          ))
        }
      </div>
    );
  }
}

export default ProgressBar;
